import { Ref, ref, computed } from "vue";
import { OptionService } from "@/service/OptionService";
/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(0); // APIで読み込みをする本数
  const isError = ref(false);

  // form情報
  const form = ref({});
  const options = ref();

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    form,
    options,
    isLoading,
    isError,
  }
}
